let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hOtWz")).then(() => parcelRequire('dWyK3'));